import { render, staticRenderFns } from "./SelectVendedor.vue?vue&type=template&id=dec021e0"
import script from "./SelectVendedor.vue?vue&type=script&lang=js"
export * from "./SelectVendedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports